import { render, staticRenderFns } from "./textTips.vue?vue&type=template&id=afa2ff6e&scoped=true&"
import script from "./textTips.vue?vue&type=script&lang=js&"
export * from "./textTips.vue?vue&type=script&lang=js&"
import style0 from "./textTips.vue?vue&type=style&index=0&id=afa2ff6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa2ff6e",
  null
  
)

export default component.exports